<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4828_41)">
<path d="M8.49985 6.26483C8.04446 6.26784 7.60857 6.45007 7.28656 6.77209C6.96454 7.09411 6.7823 7.52999 6.7793 7.98538C6.7793 8.9271 7.55813 9.70594 8.49985 9.70594C9.44099 9.70594 10.2204 8.9271 10.2204 7.98538C10.2204 7.04424 9.44099 6.26483 8.49985 6.26483Z" fill="black"/>
<path d="M8.50003 3.97076C4.12237 3.97076 2.80672 7.76573 2.79468 7.80415L2.73389 7.98539L2.79411 8.16662C2.80672 8.20504 4.12237 12 8.50003 12C12.8777 12 14.1933 8.20504 14.2054 8.16662L14.2662 7.98539L14.206 7.80415C14.1933 7.76573 12.8777 3.97076 8.50003 3.97076ZM8.50003 10.853C5.43114 10.853 4.24224 8.64722 3.95433 7.98539C4.24338 7.32125 5.43286 5.1178 8.50003 5.1178C11.5689 5.1178 12.7578 7.32355 13.0457 7.98539C12.7567 8.64952 11.5672 10.853 8.50003 10.853V10.853Z" fill="black"/>
<path d="M12.5 0.5L16 0.5L16 4" stroke="black"/>
<path d="M4.5 15.5L1 15.5L1 12" stroke="black"/>
</g>
<defs>
<clipPath id="clip0_4828_41">
<rect width="16" height="16" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
